import usePageTheme from "./usePageTheme";

// Shows the park painting behind the page (lobby, social...)
const useScenicBackground = () => usePageTheme("park");

export default useScenicBackground;
